module.exports = __webpack_public_path__ + "f5518ab0c93fe847dd2b4efcaa0e97e5.svg";